import { useMemo, useState } from 'react';
import { useTranslation } from 'next-i18next/pages';
import { type Listing } from '@pkgs/api';
import { Headline } from '@ev-tech/ui-core-components/Headline';

import { getCountrySpecificDetail } from '@/utils/countrySpecificDetailUtil';
import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { ArrowDownIcon } from '@/components/common/Icons/ArrowDownIcon';

import { PropertyFact } from './PropertyFact';
import { prepareDetailsColumns } from './prepareDetailsColumns';

import styles from './PropertyDetails.module.css';

export const CountrySpecificPropertyDetail = ({ listing }: { listing: Listing }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE.property_expose);
  const [isOpen, setIsOpen] = useState(false);

  const countrySpecificPropertyDetail = useMemo(() => getCountrySpecificDetail(listing, t), [listing, t]);

  const [leftColumn, rightColumn] = prepareDetailsColumns(countrySpecificPropertyDetail);

  return (
    <div className={styles.detailsContainer}>
      <div className={styles.dropdownContainer} onClick={() => setIsOpen(!isOpen)}>
        <Headline size="h5" as="span" label={t('search.expose.countrySpecific.headline')} />
        <div className={styles.dropdownIconContainer} data-open={isOpen}>
          <ArrowDownIcon />
        </div>
      </div>
      <div className={styles.contentWrapper} data-open={isOpen}>
        <div className={styles.contentInner}>
          <div className={styles.columnContainer}>
            <ul className={styles.list}>
              {leftColumn.map((item, index) => (
                <PropertyFact {...item} key={index} isLast={index === leftColumn.length - 1} />
              ))}
            </ul>
            <ul className={styles.list}>
              {rightColumn.map((item, index) => (
                <PropertyFact {...item} key={index} isLast={index === rightColumn.length - 1} />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
